import { BaseModel } from './base.model';
import { Contract } from './contract.model';
import { Lead } from './lead.model';
import { Unit } from './unit.model';

export class Offer extends BaseModel {
  static STATUS_PENDING = 'pending';
  static STATUS_SENT = 'sent';
  static STATUS_ACCEPTED = 'accepted';
  static STATUS_DECLINED = 'declined';
  static STATUS_EXPIRED = 'expired';
  static STATUS_SIGNED = 'signed';
  static STATUS_TERMINATED = 'terminated';

  id?: number;
  leadId!: number;
  hash!: string;
  moveInDate!: string;
  validityDays!: number;
  validUntil?: string;
  securityDeposit?: string | null;
  minRentMonths?: number | null;
  totalNetCost?: string | null;
  totalAuxiliaryCost?: string | null;
  status!: string;

  sentAt?: string | null;
  acceptedAt?: string | null;
  declinedAt?: string | null;
  expiredAt?: string | null;

  createdAt?: string;
  updatedAt?: string;

  lead?: Lead;
  units?: Unit[];
  contracts?: Contract[];
  primaryUnit?: Unit;
  additionalUnits?: Unit[];

  get childModels() {
    return {
      lead: Lead,
      units: Unit,
      contracts: Contract,
      primaryUnit: Unit,
      additionalUnits: Unit,
    };
  }

  get totalGrossCost(): number {
    return Number(this.totalNetCost ?? 0) + Number(this.totalAuxiliaryCost ?? 0);
  }
}
